var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line",style:({
    background: _vm.color,
    width: _vm.width,
    height: _vm.height,
    'border-radius': _vm.type === 'circle' ? '50%' : null
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }